import { TelemetryLevel } from '@qodana/blocks/lib/components/Legal'

import { RatingDescription } from './feedback'
import { OrganizationId, UserRole } from './organization'
import { TeamId } from './team'

export type UserConfiguration = {
	telemetryLevel?: TelemetryLevel
	isOnboarded?: boolean
	newsletterViewed?: boolean
}

export type CurrentUser = {
	id: string
	email: string
	fullName?: string
	isAnonymous: boolean
	configuration?: UserConfiguration
	agreements: Record<
		string,
		{
			actualVersion: string
			acceptedVersion?: string
		}
	>
}

export type LicenseAgreement = {
	id: number
	version: string
	name: string
	effectiveFrom: string
}

export type TeamUser = {
	email: string
	id: string
	role: UserRole
	isActive: boolean
}

export type UserPermission = {
	organizations: Permission[]
	projects: Permission[]
	teams: Permission[]
}

export type Permission = {
	id: string
	permissions: string[]
	role: UserRole
}

export enum TeamUserStatus {
	notMember = 'NOT_MEMBER',
	pendingMembershipRequest = 'PENDING_MEMBERSHIP_REQUEST',
	member = 'MEMBER',
}

export type UserFeedback = {
	rating: RatingDescription
	feedback: string
}

export type EntityLevelFilter = {
	organizationId?: OrganizationId
	teamId?: TeamId
} & ({ organizationId: OrganizationId } | { teamId: TeamId })
